import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { BellRing, Calendar, Check } from "lucide-react";
import { toast } from "sonner";

export default function RemindersList() {
  const [items, setItems] = useState([]);

  const load = async () => {
    const { data } = await api.get("/reminders");
    setItems(data);
  };
  useEffect(() => { load(); }, []);

  const toggle = async (oid, rid) => {
    try {
      await api.post(`/orders/${oid}/reminders/${rid}/toggle`);
      load();
    } catch { toast.error("Failed"); }
  };

  const now = new Date();
  const overdue = items.filter((r) => !r.done && new Date(r.due_at) < now);
  const upcoming = items.filter((r) => !r.done && new Date(r.due_at) >= now);
  const done = items.filter((r) => r.done);

  const Section = ({ title, list, accent }) => (
    <div>
      <h3 className="font-heading font-bold text-xl tracking-tight mb-3 flex items-center gap-2">
        <span className={`w-2 h-2 rounded-full ${accent}`} /> {title} <span className="text-zinc-400 num">({list.length})</span>
      </h3>
      {list.length === 0 ? (
        <div className="text-sm text-zinc-500 mb-6">Nothing here.</div>
      ) : (
        <Card className="p-0 overflow-hidden mb-6">
          <ul className="divide-y divide-border">
            {list.map((r) => (
              <li key={r.id} className={`flex items-start gap-3 p-4 ${r.done ? "opacity-50" : ""}`}>
                <button
                  onClick={() => toggle(r.order_id, r.id)}
                  className={`mt-0.5 w-5 h-5 rounded border ${r.done ? "bg-zinc-900 border-zinc-900 text-white" : "border-zinc-300"} grid place-items-center flex-shrink-0`}
                  data-testid={`reminder-toggle-${r.id}`}
                >
                  {r.done && <Check className="w-3 h-3" />}
                </button>
                <div className="flex-1 min-w-0">
                  <div className={`font-medium text-sm ${r.done ? "line-through" : ""}`}>{r.title}</div>
                  <div className="text-xs text-zinc-500 mt-0.5">
                    <Calendar className="inline w-3 h-3 mr-1" />
                    {new Date(r.due_at).toLocaleString()}
                    {" · "}
                    <Link to={`/orders/${r.order_id}`} className="hover:underline">
                      {r.order_no} {r.order_title}
                    </Link>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </Card>
      )}
    </div>
  );

  return (
    <div className="space-y-4">
      <div>
        <div className="overline text-zinc-500">Schedule</div>
        <h1 className="font-heading font-black text-4xl sm:text-5xl tracking-tighter mt-1 flex items-center gap-3">
          Reminders <BellRing className="w-7 h-7 text-gold-500" />
        </h1>
      </div>
      <Section title="Overdue" list={overdue} accent="bg-red-500" />
      <Section title="Upcoming" list={upcoming} accent="bg-yellow-500" />
      <Section title="Completed" list={done} accent="bg-emerald-500" />
    </div>
  );
}
